/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GET_CALENDARS_REQUEST,
  GET_CALENDARS_SUCCESS,
  GET_CALENDARS_FAILURE,
  CREATE_CALENDAR_REQUEST,
  CREATE_CALENDAR_SUCCESS,
  CREATE_CALENDAR_FAILURE,
  UPDATE_CALENDAR_REQUEST,
  UPDATE_CALENDAR_SUCCESS,
  UPDATE_CALENDAR_FAILURE,
  DELETE_CALENDAR_REQUEST,
  DELETE_CALENDAR_SUCCESS,
  DELETE_CALENDAR_FAILURE,
  GET_CALENDARS_FOR_HOME_REQUEST,
  GET_CALENDARS_FOR_HOME_SUCCESS,
  GET_CALENDARS_FOR_HOME_FAILURE,
} from "./calendarTypes";

import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;
// let baseUrl = `http://13.71.2.248:1338/api/v2/users_management`;

const getCalendarsRequest = () => {
  return {
    type: GET_CALENDARS_REQUEST,
  };
};

const getCalendarsSuccess = (payload) => {
  return {
    type: GET_CALENDARS_SUCCESS,
    payload: payload,
  };
};

const getCalendarsFaliure = (error) => {
  return {
    type: GET_CALENDARS_FAILURE,
    payload: error,
  };
};

const getCalendars = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getCalendarsRequest());
    let url = `${baseUrl}/calendar/get?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getCalendarsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getCalendarsFaliure(err.response));
      });
  };
};

const createCalendarRequest = () => {
  return {
    type: CREATE_CALENDAR_REQUEST,
  };
};

const createCalendarSuccess = (payload) => {
  return {
    type: CREATE_CALENDAR_SUCCESS,
    payload: payload,
  };
};

const createCalendarFaliure = (error) => {
  return {
    type: CREATE_CALENDAR_FAILURE,
    payload: error,
  };
};

const createCalendar = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createCalendarRequest());
    let url = `${baseUrl}/calendar/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createCalendarSuccess(response.data));
        return response.data;
      })
      .catch((err) => {
        dispatch(createCalendarFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateCalendarRequest = () => {
  return {
    type: UPDATE_CALENDAR_REQUEST,
  };
};

const updateCalendarSuccess = (payload) => {
  return {
    type: UPDATE_CALENDAR_SUCCESS,
    payload: payload,
  };
};

const updateCalendarFaliure = (error) => {
  return {
    type: UPDATE_CALENDAR_FAILURE,
    payload: error,
  };
};

const updateCalendar = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateCalendarRequest());
    let url = `${baseUrl}/calendar/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateCalendarSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateCalendarFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deleteCalendarRequest = () => {
  return {
    type: DELETE_CALENDAR_REQUEST,
  };
};

const deleteCalendarSuccess = (payload) => {
  return {
    type: DELETE_CALENDAR_SUCCESS,
    payload: payload,
  };
};

const deleteCalendarFaliure = (error) => {
  return {
    type: DELETE_CALENDAR_FAILURE,
    payload: error,
  };
};

const deleteCalendar = (calendarId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deleteCalendarRequest());
    let url = `${baseUrl}/calendar/delete?id=${calendarId}`;
    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteCalendarSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteCalendarFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getCalendarsForHomeRequest = () => {
  return {
    type: GET_CALENDARS_FOR_HOME_REQUEST,
  };
};

const getCalendarsForHomeSuccess = (payload) => {
  return {
    type: GET_CALENDARS_FOR_HOME_SUCCESS,
    payload: payload,
  };
};

const getCalendarsForHomeFaliure = (error) => {
  return {
    type: GET_CALENDARS_FOR_HOME_FAILURE,
    payload: error,
  };
};

const getCalendarsForHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getCalendarsForHomeRequest());
    let url = `${baseUrl}/calendar/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getCalendarsForHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getCalendarsForHomeFaliure(err.response));
      });
  };
};

export {
  getCalendars,
  createCalendar,
  updateCalendar,
  deleteCalendar,
  getCalendarsForHome,
};
